import type { SiroccoEvent } from '@sirocco/shared';
import { events, type SortiesAVenir } from '../../api/endpoints';
import { readScreenCache } from '../../hooks/useAsync';

/** La cle sous laquelle la liste et la carte gardent les memes sorties. */
export const CLE_DES_SORTIES = 'events';

/**
 * Les sorties a venir, sans celles publiees depuis qu'on regarde.
 *
 * Comme le fil : changer d'onglet et revenir remet sous les yeux la liste
 * qu'on avait laissee, et le neuf n'arrive qu'en tirant — ou au prochain
 * lancement, quand le cache de session est vide. Une sortie apparue en
 * route poussait sinon les autres a chaque retour, et la liste ne restait
 * jamais celle qu'on venait de lire.
 *
 * Mais seules les nouvelles attendent. Celles deja affichees se relisent
 * quand meme : une sortie annulee disparait, une place prise se voit, une
 * inscription faite depuis la fiche se retrouve sur la carte. Figer la
 * liste entiere, comme le fil, aurait montre des etats faux pour des
 * sorties ou l'on doit agir.
 *
 * Passent aussi celles qui me concernent : la sortie que je viens de
 * creer, celle ou je viens de m'inscrire depuis un lien. Les faire
 * attendre un tirage ferait croire qu'elles n'ont pas ete enregistrees.
 */
export async function sortiesVues(toutes: boolean, moi: string | undefined): Promise<SortiesAVenir> {
  // Lu avant la reponse : c'est ce qui etait affiche quand on a demande.
  const affichees = readScreenCache<SortiesAVenir>(CLE_DES_SORTIES);
  const fraiches = await events.aVenir('');
  if (toutes || !affichees) return fraiches;

  const connues = new Set(affichees.sorties.map((sortie) => sortie.id));
  const retenue = (sortie: SiroccoEvent) =>
    connues.has(sortie.id) ||
    sortie.organizer.id === moi ||
    sortie.myStatus === 'confirmed' ||
    sortie.myStatus === 'pending';

  return {
    sorties: fraiches.sorties.filter(retenue),
    pourToi: fraiches.pourToi.filter(retenue),
  };
}
